import {DropdownMenu} from '@wandb/components';
import React from 'react';

import {Analytics} from '../../../services/analytics';
import * as GroupSelectionsActions from '../../../state/views/groupSelections/actions';
import {useViewAction} from '../../../state/views/hooks';
import {hideColumns, togglePinned} from '../../../util/tablecols';
import {useRunSelectorAnalyticsLocation} from '../RunSelectorAnalyticsLocationContext';
import {
  useRunSetGroupSelectionGrouping,
  useRunSetGroupSelectionsRef,
} from '../RunSelectorRunSetContext';
import {
  useSetTableSettings,
  useTableSettings,
} from '../RunSelectorTableSettingsContext';
import type {WBTableColumn} from '../WBTable/types';
import {MenuItem} from './MenuItem';

type ColumnPinningItemsProps = {
  column: WBTableColumn;
};
export function PinningGroup({column}: ColumnPinningItemsProps) {
  const tableSettings = useTableSettings();
  const setTableSettings = useSetTableSettings();
  const analyticsLocation = useRunSelectorAnalyticsLocation();
  const groupSelectionsRef = useRunSetGroupSelectionsRef();
  const grouping = useRunSetGroupSelectionGrouping();
  const setGrouping = useViewAction(
    groupSelectionsRef,
    GroupSelectionsActions.setGrouping
  );

  const pinned = tableSettings.columnPinned[column.accessor];
  const isConfigColumn = column.key.section === 'config';

  function handleTogglePinnedColumn() {
    Analytics.track('Pin column clicked', {
      location: analyticsLocation,
    });
    setTableSettings(s => togglePinned(s, column.accessor));
  }

  function handleHideColumn() {
    Analytics.track('Hide column clicked', {
      location: analyticsLocation,
    });
    setTableSettings(s => hideColumns(s, [column.accessor]));
  }

  function handleGroupBy() {
    Analytics.track('Group by column clicked', {
      location: analyticsLocation,
    });
    setGrouping([...grouping, column.key]);
  }

  return (
    <DropdownMenu.Section>
      <MenuItem
        data-dd-action-name={pinned ? 'Unpin column' : 'Pin column'}
        icon="pin"
        onAction={handleTogglePinnedColumn}>
        {pinned ? 'Unpin' : 'Pin'} column
      </MenuItem>
      <MenuItem
        data-dd-action-name="Hide column"
        icon="hide"
        onAction={handleHideColumn}>
        Hide column
      </MenuItem>
      {isConfigColumn && (
        <MenuItem
          data-dd-action-name="Group by column"
          icon="group"
          onAction={handleGroupBy}>
          Group by
        </MenuItem>
      )}
    </DropdownMenu.Section>
  );
}
